import { useEffect, useRef, useContext, useState } from "react"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import SubstanceUse2 from "../Forms/B/SubstanceUse/SubstanceUse2"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const SubstanceUse2Container = ({ showToolBar, disabled, interview_id }) => {
  const { interview, handleSubmitGet, handleLoadPrev, loadCollection } =
    useContext(GpraContext)
  const userCtx = useContext(UserContext)

  const [isGettingSubstanceUse, setIsGettingSubstanceUse] = useState(true)

  const toast = useRef()

  useEffect(() => {
    if (
      interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id ||
      interview_id
    ) {
      setIsGettingSubstanceUse(true)
      handleSubmitGet(endpoints.GET_SUBSTANCE_USE_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.SUBSTANCE_USE_2,
      })
        .then((response) => {
          loadCollection(
            setValues(response.data),
            INTERVIEW_SECTIONS.SUBSTANCE_USE_2
          )
          handleLoadPrev(false)
          setIsGettingSubstanceUse(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingSubstanceUse(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setValues = (data) => {
    return {
      ...data?.form,
      gpra_b_2a: data?.form?.gpra_b_2a ?? undefined,
      gpra_b_2a_days: data?.form?.gpra_b_2a_days ?? 0,
      gpra_b_2b: data?.form?.gpra_b_2b ?? undefined,
      gpra_b_2b_days: data?.form?.gpra_b_2b_days ?? 0,
      gpra_b_2c: data?.form?.gpra_b_2c ?? undefined,
      gpra_b_2c_days: data?.form?.gpra_b_2c_days ?? 0,
      gpra_b_2d: data?.form?.gpra_b_2d ?? undefined,
      gpra_b_2d_days: data?.form?.gpra_b_2d_days ?? 0,
      gpra_b_2e: data?.form?.gpra_b_2e ?? undefined,
      gpra_b_2f: data?.form?.gpra_b_2f ?? undefined,
      gpra_b_3a: data?.form?.gpra_b_3a ?? undefined,
      gpra_b_3a_days: data?.form?.gpraB3aDays ?? 0,
      gpra_b_3b: data?.form?.gpra_b_3b ?? undefined,
      gpra_b_3b_days: data?.form?.gpra_b_3b_days ?? 0,
      gpra_b_3c: data?.form?.gpra_b_3c ?? undefined,
      gpra_b_3c_days: data?.form?.gpra_b_3c_days ?? 0,
      gpra_b_3d: data?.form?.gpra_b_3d ?? undefined,
      gpra_b_3d_days: data?.form?.gpra_b_3d_days ?? 0,
      gpra_b_3e: data?.form?.gpra_b_3e ?? undefined,
      gpra_b_3f: data?.form?.gpra_b_3f ?? undefined,
      gpra_b_4a: data?.form?.gpra_b_4a ?? undefined,
      gpra_b_4a_days: data?.form?.gpra_b_4a_days ?? 0,
      gpra_b_4b: data?.form?.gpra_b_4b ?? undefined,
      gpra_b_4b_days: data?.form?.gpra_b_4b_days ?? 0,
      gpra_b_4c: data?.form?.gpra_b_4c ?? undefined,
      gpra_b_4c_days: data?.form?.gpra_b_4c_days ?? 0,
      gpra_b_4d: data?.form?.gpra_b_4d ?? undefined,
      gpra_b_4d_days: data?.form?.gpra_b_4d_days ?? 0,
      gpra_b_4e: data?.form?.gpra_b_4e ?? undefined,
      gpra_b_4f: data?.form?.gpra_b_4f ?? undefined,
      gpra_b_5a: data?.form?.gpra_b_5a ?? undefined,
      gpra_b_5a_days: data?.form?.gpra_b_5a_days ?? 0,
      gpra_b_5b: data?.form?.gpra_b_5b ?? undefined,
      gpra_b_5b_days: data?.form?.gpra_b_5b_days ?? 0,
      gpra_b_5c: data?.form?.gpra_b_5c ?? undefined,
      gpra_b_5c_days: data?.form?.gpra_b_5c_days ?? 0,
      gpra_b_5d: data?.form?.gpra_b_5d ?? undefined,
      gpra_b_5e: data?.form?.gpra_b_5e ?? undefined,
      gpra_b_id: data?.form?.gpra_b_id ?? 0,
      additional: data?.additional ?? [],
    }
  }
  if (isGettingSubstanceUse) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingSubstanceUse && (
        <SubstanceUse2 showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default SubstanceUse2Container
